import { CurrencyCircleDollar, Network, Coins, TrendUp, ChartBar, RocketLaunch, ShieldCheck, Star } from "@phosphor-icons/react";

const MAP = {
  currency: CurrencyCircleDollar,
  network: Network,
  gold: Coins,
  rising: TrendUp,
  candles: ChartBar,
  rocket: RocketLaunch,
  shield: ShieldCheck,
  star: Star,
};

export const AssetIcon = ({ name, size = 28, className = "", weight = "duotone" }) => {
  const Icon = MAP[name] || RocketLaunch;
  return <Icon size={size} weight={weight} className={className} />;
};

export const AssetRing = ({ name, label, dark = true }) => (
  <div className="flex flex-col items-center gap-3">
    <div className={`flex h-20 w-20 items-center justify-center rounded-full border-2 ${dark ? "border-sky-400/70 bg-[#0B1B33]" : "border-[#0B1B33]/20 bg-white"} transition-transform duration-200 hover:-translate-y-1`}>
      <AssetIcon name={name} size={34} className="text-[#E0A21B]" />
    </div>
    {label && <span className={`font-display text-lg font-bold uppercase tracking-widest ${dark ? "text-white" : "text-[#0B1B33]"}`}>{label}</span>}
  </div>
);
